import PropTypes from 'prop-types';
import styles from './FJImageInput.module.less';
import ReUploadIcon from '../../../assets/svg/re-upload.svg?react';
import UploadIcon from '../../../assets/svg/upload.svg?react';
import AddFileIcon from '../../../assets/svg/add-file.svg?react';
import AddFileWhiteIcon from '../../../assets/svg/add-file-white.svg?react';
import FJLocalStore from '../../../store/FJLocalStore';
import classNames from 'classnames';
import FJToolTip from '../FJToolTip/FJToolTip';
import { useRef } from 'react';
import FJPreviewBox from '../FJPreviewBox/FJPreviewBox';
import FJConstant from '../../../constants/FJConstant';

const FJImageInput = props => {
    const {
        isDraggingFile,
        uploadImageInfo = {},
        uploadImg,
        setIsDraggingFile,
        acceptFile,
        taskStatus,
        openMediaLibrary,
    } = props;
    const { src: imgSrc, width, height } = uploadImageInfo;
    const inputRef = useRef(null);
    const _onUploadImg = e => {
        const file = e.target.files[0];
        uploadImg(file);
        e.target.value = null;
    };
    const _onUpload = () => {
        if (taskStatus !== FJConstant.DEFAULT) {
            return;
        }

        if (window.isEditPage && openMediaLibrary) {
            openMediaLibrary();
        } else if (inputRef.current) {
            inputRef.current.click();
        }
    };
    const _onDragOver = e => {
        e.stopPropagation();
        e.preventDefault();
        setIsDraggingFile(true);
    };

    const _onDragLeave = e => {
        e.stopPropagation();
        e.preventDefault();
        setIsDraggingFile(false);
    };

    const _onDragDrop = e => {
        e.stopPropagation();
        e.preventDefault();
        setIsDraggingFile(false);
        let files = e.dataTransfer.files;
        if (files && files.length > 0) {
            const file = files[0];
            uploadImg(file);
        }
    };
    const imgInfo = imgSrc && `${width} * ${height} px`;
    return (
        <div className={styles.input_box} onDragOver={_onDragOver} onDrop={_onDragDrop} onDragLeave={_onDragLeave}>
            {imgSrc ? (
                <div className={styles.img_content}>
                    <div className={styles.img_box}>
                        <img className={styles.img} src={imgSrc} alt='' loading='lazy' />
                        <FJPreviewBox imageInfo={uploadImageInfo} className={styles.mask} />
                    </div>
                    <div className={styles.img_info}>
                        <span className={styles.img_info_title}>{FJLocalStore._('image')}</span>
                        <span className={styles.img_info_text}>{imgInfo}</span>
                    </div>
                    <FJToolTip title={FJLocalStore._('change-image')}>
                        <div
                            className={classNames(
                                styles.reload_icon,
                                taskStatus !== FJConstant.DEFAULT ? styles.reload_icon_disabled : '',
                            )}
                            onClick={_onUpload}
                        >
                            <ReUploadIcon />
                        </div>
                    </FJToolTip>
                </div>
            ) : (
                <div className={styles.blank} onClick={_onUpload}>
                    {isDraggingFile ? <AddFileIcon /> : <UploadIcon />}
                    <span className={styles.blank_text}>
                        {isDraggingFile ? FJLocalStore._('drag-and-drop') : FJLocalStore._('upload-image')}
                    </span>
                </div>
            )}

            {isDraggingFile && (
                <div className={classNames(styles.filter_mask, isDraggingFile ? styles.dragging : '')}>
                    <AddFileWhiteIcon />
                    <span className={styles.filter_mask_text}>{FJLocalStore._('drag-and-drop')}</span>
                </div>
            )}
            <div className={styles.dragging_mask}></div>

            <input
                type='file'
                ref={inputRef}
                className={styles.file_input}
                accept={acceptFile}
                onChange={_onUploadImg}
            />
        </div>
    );
};
FJImageInput.propTypes = {
    uploadImageInfo: PropTypes.object,
    uploadImg: PropTypes.func,
    isDraggingFile: PropTypes.bool,
    setIsDraggingFile: PropTypes.func,
    openMediaLibrary: PropTypes.func,
    acceptFile: PropTypes.string,
    taskStatus: PropTypes.string,
};
export default FJImageInput;
